/*eslint-disable*/
export default {
    props: {
        answerDuration: Number,
    },
    data () {
        return {
            answerTimer: null,
            answerTime: 0,
        }
    },
    methods: {
        startAnswerTimer () {
            this.answerTimer = setInterval(() => {
                if (this.gameStarted) {
                    this.answerTime++;
                    if (this.answerTime === this.answerDuration && !this.navigatorTable) {
                        this.processReply();
                    } else if (this.answerTime === this.answerDuration) {
                        this.handleClick(null, 1, 1);
                    }
                }
            }, 1000);
        },
        stopAnswerTimer () {
            if (this.answerDuration) {
                this.answerTime = 0;
                clearInterval(this.answerTimer);
            }
        },
    },
    beforeDestroy () {
        this.stopAnswerTimer();
    }
}
